import { getOrganizationViewUrl } from '../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../utils/routing/reactRoute'

// Every URL the Invoice Editor is reachable at.
// These URLs are served by a single <Route> (see InvoiceEditorRoute) rather than
// one per path, so that moving between them keeps the editor mounted.
export const getInvoiceEditorRoutePaths = (organizationUrl: string): string[] => {
  const { invoices } = reactRoute.organization

  return [
    invoices.getNewDocumentRoute(),
    invoices.getEditDocumentDraftRoute(),
    invoices.getEditDocumentRoute(),
    invoices.getDuplicateDocumentRoute(),
    invoices.getDuplicateDocumentDraftRoute(),
    invoices.getInvoiceFromQuoteRoute(),
    invoices.getDepositInvoiceFromQuoteRoute(),
    invoices.getFinalInvoiceFromQuoteRoute(),
    invoices.getEditDepositInvoiceDraftRoute(),
    invoices.getEditFinalInvoiceDraftRoute(),
    invoices.getCreditNoteFromInvoiceRoute(),
  ].map((route) => getOrganizationViewUrl(organizationUrl, route))
}
